import { 
  Plug, Zap, Fan, Lightbulb, Shield, Battery, AlertCircle, Wrench, Clock,
  Camera, Monitor, Eye, Network, Server, Phone, Wifi, Cpu, Power,
  FileText, Key, Fingerprint, Lock, Radio, Building
} from 'lucide-react';

export const ITEM_ICONS = {
  outlet_installation: Plug, outlet_repair: Plug, gfci_outlet: Plug, switch_installation: Zap,
  dimmer_switch: Zap, ceiling_fan: Fan, light_fixture: Lightbulb, chandelier: Lightbulb,
  recessed_lighting: Lightbulb, panel_upgrade_100a: Shield, panel_upgrade_200a: Shield,
  circuit_breaker: Shield, dedicated_circuit: Zap, ev_charger_level2: Battery,
  whole_house_surge: Shield, smoke_detector: AlertCircle, carbon_monoxide: AlertCircle,
  rewiring_per_sqft: Wrench, service_call: Wrench, hourly_rate: Clock,
  camera_indoor: Camera, camera_outdoor: Camera, camera_ptz: Camera, camera_bullet: Camera,
  camera_dome: Camera, camera_license_plate: Camera, dvr_4ch: Monitor, dvr_8ch: Monitor,
  nvr_16ch: Monitor, nvr_32ch: Monitor, nvr_64ch: Monitor, doorbell_camera: Eye,
  cable_run: Network, monitor_setup: Monitor, cloud_setup: Server, mobile_app_setup: Phone,
  video_analytics: Eye, central_monitoring: Eye, server_installation: Server,
  cat6_drop: Network, cat6a_drop: Network, wifi_access_point: Wifi, mesh_wifi_system: Wifi,
  router_setup: Wifi, network_switch: Server, patch_panel: Server, patch_panel_24: Server,
  patch_panel_48: Server, smart_home_hub: Cpu, ethernet_wall_jack: Network,
  fiber_optic: Network, fiber_run_per_ft: Network, server_rack: Server,
  enterprise_switch: Server, enterprise_wifi: Wifi, network_audit: FileText,
  portable_hookup: Power, transfer_switch_manual: Power, transfer_switch_auto: Power,
  standby_7kw: Power, standby_12kw: Power, standby_22kw: Power, battery_backup: Battery,
  maintenance_annual: Wrench, transfer_switch_100a: Power, transfer_switch_200a: Power,
  generator_25kw: Power, generator_50kw: Power, generator_100kw: Power,
  ups_system: Battery, load_bank_test: Wrench, maintenance_contract: Wrench,
  video_intercom_unit: Phone, audio_intercom: Phone, door_station: Phone,
  indoor_monitor: Monitor, gate_intercom: Radio, smartphone_integration: Phone,
  wiring_per_station: Wrench, lobby_panel: Monitor, tenant_station: Phone,
  video_entry: Eye, telephone_entry: Phone, multi_tenant_system: Building,
  pa_system: Radio, nurse_call: Phone,
  smart_lock: Key, keypad_lock: Key, electric_strike: Lock, magnetic_lock: Lock,
  garage_door_keypad: Key, gate_opener: Key, video_doorbell_lock: Eye,
  card_reader: Key, biometric_reader: Fingerprint, door_controller: Lock,
  electric_strike_commercial: Lock, magnetic_lock_1200lb: Lock, turnstile: Lock,
  mantrap: Shield, access_panel_4door: Lock, access_panel_8door: Lock,
  software_license: Cpu, credential_programming: Key
};

export const CATEGORY_COLORS = {
  electrical: { bg: 'bg-yellow-500/10', border: 'border-yellow-500/30', text: 'text-yellow-400', icon: 'text-yellow-500' },
  cctv: { bg: 'bg-blue-500/10', border: 'border-blue-500/30', text: 'text-blue-400', icon: 'text-blue-500' },
  networking: { bg: 'bg-cyan-500/10', border: 'border-cyan-500/30', text: 'text-cyan-400', icon: 'text-cyan-500' },
  generator: { bg: 'bg-orange-500/10', border: 'border-orange-500/30', text: 'text-orange-400', icon: 'text-orange-500' },
  intercom: { bg: 'bg-purple-500/10', border: 'border-purple-500/30', text: 'text-purple-400', icon: 'text-purple-500' },
  access_control: { bg: 'bg-red-500/10', border: 'border-red-500/30', text: 'text-red-400', icon: 'text-red-500' }
};
